import {
  SticksDataProvider,
  SticksProductDetails,
  type SticksProductDetailsProps,
} from "@product-details/containers/SticksProductDetailsContainer";

import { getFallbackProductSkus, getSticksWithAggregationsMap } from "./utils";

export const SticksProductDetailsPage = (props: SticksProductDetailsProps) => {
  const { sticksData } = props;

  const fallbackProductSkus = getFallbackProductSkus(sticksData);

  const sticksMap = getSticksWithAggregationsMap(sticksData);

  return (
    <SticksDataProvider sticksMap={sticksMap} fallbackProductsSkus={fallbackProductSkus} {...props}>
      <SticksProductDetails />
    </SticksDataProvider>
  );
};
